module.exports = __webpack_public_path__ + "img/WhatsApp.c7bac187.png";